import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { Feature } from '../feature'

/**
 * Clears the current pulse whenever the zone changes
 */
export const clearPulseOnZoneChange = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    meFeature.contexts.selectors.zoneContext.asObservable.pipe(
      rxjs.map(() =>
        feature.actions.clear.from('clearPulseOnZoneChange').create(),
      ),
    ),
)
